import { makeVar } from '@apollo/client/core';
import { selectionItem } from './selection.model';

export const selectionHistory = makeVar<selectionItem[]>([]);

export const selectionStickys = makeVar<selectionItem[]>([]);
